import styled from 'styled-components';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import { FontWeight, PRESSABLE, STANDARD_TRANSITION } from '../../../../common/styles/constants';
import { onMobile } from '../../../../common/styles/onMobile';

export const ResultCountView = styled.div`
  ${STANDARD_TRANSITION};
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 32px;
  padding-top: 16px;
  width: 592px;

  ${onMobile} {
    margin-inline-end: auto;
    margin-inline-start: auto;
    width: 224px;
  }
`;

export const Text = styled.div`
  color: ${ThemeColours.black};
  font-size: 14px;
  line-height: 1.29em;
  margin-bottom: 16px;
  text-align: center;
  width: 100%;
`;

export const Bar = styled.div`
  background-color: ${ThemeColours.mono200};
  border-radius: 4px;
  display: flex;
  height: 8px;
  margin-bottom: 24px;
  overflow: hidden;
  position: relative;
  width: 180px;
`;

export const Progress = styled.div`
  background-color: ${ThemeColours.primary700};
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
`;

export const LoadMore = styled.div`
  ${PRESSABLE}
  align-items: center;
  background-color: ${ThemeColours.buttonPrimaryFill};
  border-radius: 24px;
  color: ${ThemeColours.buttonPrimaryText};
  display: flex;
  font-size: 16px;
  font-weight: ${FontWeight.BOLD};
  height: 48px;
  justify-content: center;
  width: 180px;
`;
